'use client'
import type { Locale } from '@/i18n/config'

/**
 * 根据当前语言生成正确的feature页面链接
 * 只有feature页面有国际化路由，其他页面保持原样
 */
export function getFeatureLink(featureSlug: string, locale: Locale): string {
  // 英语使用根路径，其他语言使用语言前缀
  if (locale === 'en') {
    return `/feature/${featureSlug}`
  }
  return `/${locale}/feature/${featureSlug}`
}

/**
 * 获取feature主页链接
 */
export function getFeatureIndexLink(locale: Locale): string {
  if (locale === 'en') {
    return '/feature'
  }
  return `/${locale}/feature`
}

/**
 * 检查路径是否是feature页面
 */
export function isFeaturePage(pathname: string): boolean {
  return (
    pathname.startsWith('/feature') || /^\/[a-z]{2}\/feature/.test(pathname)
  )
}

/**
 * 从路径中提取当前语言（仅用于feature页面）
 */
export function extractLocaleFromFeaturePath(pathname: string): Locale | null {
  if (pathname.startsWith('/feature')) {
    return 'en' // 根路径默认英语
  }

  const match = pathname.match(/^\/([a-z]{2})\/feature/)
  return match ? (match[1] as Locale) : null
}
